import { useDispatch, useSelector } from 'react-redux'
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from 'reactstrap'
import {
  toggleAllAssignableStores,
  toggleAssignableGroupStores,
} from 'store/Group/actions'
import Search from '../../../Search'
import SelectedItems from '../../../SelectedItems'
import { filterRoleGroups } from 'store/Group/actions'
import { setShowSelectedRoleGroups } from 'store/Group/actions'
import { setHideSelectedRoleGroups } from 'store/Group/actions'
import { toggleAllAssignableRoleGroups } from 'store/Group/actions'
import { toggleRoleGroup } from 'store/Group/actions'
import { toggleAssignableRoleGroup } from 'store/Group/actions'

const RoleGroupsModal = (props) => {
  const dispatch = useDispatch()
  const groups = useSelector((state) => state.groups)
  const { items } = props

  const isChecked = (props, property, value) => {
    return props[property].indexOf(value) !== -1
  }

  return (
    <Modal
      className='modal-dialog-centered'
      isOpen={props.isOpen}
      size='xl'
      toggle={() => props.setRoleGroupsModal(!props.isOpen)}
      scrollable
    >
      <ModalHeader
        className='border-bottom pb-2'
        toggle={() => props.setRoleGroupsModal(false)}
      >
        <span className='text-info'>Role groups</span>
      </ModalHeader>

      <ModalBody className='scrollbar' style={{ minHeight: '60vh' }}>
        <Row className='justify-content-between px-2'>
          <p>All role groups:</p>
          <Search
            placeholder={'Search role groups'}
            value={groups.filterRoleGroupsValue}
            onChange={(e) => dispatch(filterRoleGroups(e.target.value))}
          />
        </Row>
        <div className='col'>
          <div className='col-3 mb-3 pl-0'>
            <SelectedItems
              items={
                items &&
                items.length > 0 &&
                items
                  .filter((item) =>
                    groups.assignableTrainingRoleGroups.includes(item.id)
                  )
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
              }
              selectedItems={groups.assignableTrainingRoleGroups}
              showSelectedItems={groups.showSelectedRoleGroups}
              hasDisabledProperty={false}
              onChange={toggleAssignableRoleGroup}
              setShowSelectedItems={() => dispatch(setShowSelectedRoleGroups())}
              setHideSelectedItems={() => dispatch(setHideSelectedRoleGroups())}
              // language={props.language}
            />
          </div>

          {items && items.length && !groups.filterGroupLocationsValue ? (
            <div className='custom-control custom-checkbox-info mt-4'>
              <input
                className='custom-control-input'
                id='allStores'
                type='checkbox'
                onChange={() => dispatch(toggleAllAssignableRoleGroups())}
                checked={
                  items.length === groups.assignableTrainingRoleGroups.length
                }
              />
              <label className='custom-control-label' htmlFor='allStores'>
                All
              </label>
            </div>
          ) : null}
          {items &&
            items.length > 0 &&
            items
              .filter(
                (item) =>
                  item.name &&
                  item.name
                    .toLowerCase()
                    .indexOf(groups.filterRoleGroupsValue.toLowerCase()) !== -1
              )
              .map((item, index) => (
                <div
                  key={index}
                  className='custom-control custom-checkbox-info mb-1'
                >
                  <input
                    className='custom-control-input'
                    id={`checkbox${index}`}
                    type='checkbox'
                    onChange={() =>
                      dispatch(toggleAssignableRoleGroup(item.id))
                    }
                    checked={isChecked(
                      groups,
                      'assignableTrainingRoleGroups',
                      item.id
                    )}
                  />
                  <label
                    className='custom-control-label'
                    htmlFor={`checkbox${index}`}
                  >
                    {item.name && item.name}
                  </label>
                </div>
              ))}
        </div>
      </ModalBody>

      <ModalFooter className='border-top py-2'>
        <Button
          className='ml-auto'
          color='link'
          data-dismiss='modal'
          type='button'
          onClick={() => props.setRoleGroupsModal(false)}
        >
          Close
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default RoleGroupsModal
